"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenExpiredErrorViewContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
var _view = require("../../actions/view");
var _TokenExpiredErrorView = require("./TokenExpiredErrorView");
var _ = require("../../..");
var _reactRedux = require("react-redux");
var _source = require("../../selectors/source");
function mapDispatchToProps(dispatch) {
  return {
    changeViewToPhoneAuth() {
      dispatch((0, _view.changeView)(_.EActiveView.PhoneAuth));
    }
  };
}
function mapStateToProps(state) {
  return {
    source: (0, _source.sourceSelector)(state)
  };
}
const TokenExpiredErrorViewContainer = exports.TokenExpiredErrorViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TokenExpiredErrorView.TokenExpiredErrorView);